module.exports = __webpack_public_path__ + "media/bootstrap-icons/tornado-7ff8395e.svg";